import React from 'react';

export default {
  jpl: <a href='https://www.jpl.nasa.gov/'>NASA Jet Propulsion Laboratory</a>
};

